jQuery(document).ready(function($) {

    
  /* ==========================================================================
     CENTRAL ANIMATION CONTROLLER
     ========================================================================== */
  
  const initAllAnimations = () => {
    
    // Safety Check: Wait for GSAP & ScrollTrigger
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initAllAnimations, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    // --- RUN ANIMATIONS ---
    //Home
    initHeroSplit();       // home hero gsap
    initHomeFeaturedPrdsSection(); // home featured product categories
    initImgTextSection(); // home imgtext
    initOffersSection(); // home offers animation
    initServicesGrid(); //home service section
    initMegaPrdsGrid(); //home mega grid
    initTrustBadges(); //trust badges section
    initProductSliderAnimat(); // product slider
    initHeadingTwoColSectionAnimat(); // header two col section
    initInstafeedAnimat(); // insafeed section

    //About Us
    initAbtVidSecAnimat(); //video section
    initAbtLeardershipSecAnimat();// leardership section
    initAbtAwardRecogSection();//award cards section

    //text content based
    initVogTextBasedContentPageAnimations();

    //FAQ page
    initVogFaqAnimations();

    //Collection banner
    initVogCollectionBannerAnimations();
    
  };


  /* ==========================================================================
     Home HERO SPLIT (.vog_home_hero_split) gsap animation
     ========================================================================== */
const initHeroSplit = () => {
    $('.vog_home_hero_split').each(function() {
      var $wrapper = $(this);
      
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $bentLine       = $wrapper.find(".vog_bent_line");
      var $circle         = $wrapper.find(".vog_circle");
      var $floatTargets   = $wrapper.find(".vog_float_wrapper_text, .vog_float_wrapper_btn");
      var $container      = $wrapper.find(".vog_hero_container");
      var $imgLeft        = $wrapper.find(".vog_img_left");
      var $imgRight       = $wrapper.find(".vog_img_right");
      var $mainText       = $wrapper.find(".vog_main_text");
      var $leftImgTextBox = $wrapper.find(".vog_text_box");

      if ($container.length === 0) return;

      let mm = gsap.matchMedia();

      var $floatTargetsMob   = $wrapper.find(".vog_img_inner");
      mm.add("(max-width: 1023px)", () => {
        if ($floatTargetsMob.length) gsap.to($floatTargetsMob, { y: -12, duration: 1.5, ease: "sine.inOut", repeat: -1, yoyo: true });
      });

      mm.add("(min-width: 1024px)", () => {
        
        // 1. Entrance Animations
        if ($bentLine.length) gsap.from($bentLine, { opacity: 0, scale: 0.9, duration: 1, delay: 0.5, ease: "power2.out" });
        if ($circle.length) gsap.from($circle, { scale: 0, duration: 0.6, delay: 1.1, ease: "back.out(1.7)" });
        if ($leftImgTextBox.length) gsap.from($leftImgTextBox, { opacity: 0, scale: 0.9, duration: 1, delay: 0.5, ease: "power2.out" });

        // 2. Floating Animation
        var floatAnim = gsap.to($floatTargets, { y: -32, duration: 1.5, ease: "sine.inOut", repeat: -1, yoyo: true });

        // 3. ScrollTrigger Timeline
        var scrollTl = gsap.timeline({
          scrollTrigger: {
            trigger: $container[0],
            start: "top top",
            end: "+=2000",
            scrub: 1,
            pin: true,
            invalidateOnRefresh: false,
            onUpdate: function(self) {
              if (self.progress > 0.01) {
                floatAnim.pause();
                gsap.to($floatTargets, { y: 0, duration: 0.5, overwrite: true });
              } else {
                floatAnim.play();
              }
            },
            toggleClass: { targets: ".vog_header_row", className: "vog_header_disseapear" }
          }
        });

        scrollTl
          .to($imgLeft,  { x: "-120%", opacity: 0, duration: 2, ease: "power2.inOut" }, 0)
          .to($imgRight, { x: "120%",  opacity: 0, duration: 2, ease: "power2.inOut" }, 0)
          .fromTo($mainText, 
            { fontSize: "8.2vw", opacity: 0.8, color: "white", webkitTextStroke: "1px rgba(255, 255, 255, 0.3)" }, 
            { fontSize: "8.3vw", opacity: 1, color: "white", webkitTextStroke: "1px rgba(255, 255, 255, 0)", duration: 2, ease: "power2.out" }, 0.1
          );
      });
    });
  };


/* ==========================================================================
     Home image with text section
     ========================================================================== */

  const initImgTextSection = () => {
    $('.vog_img_text_section').each(function() {
      var $wrapper = $(this);
      
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $leftImage   = $wrapper.find(".vog_col_image img");
      var $rightInner  = $wrapper.find(".vog_content_inner");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 75%",
          // FIX: Changed from 'play none none reverse' to 'play none none none'
          // This prevents the animation from reversing/restarting when cart opens
          toggleActions: "play none none none" 
        }
      });

      tl.from($leftImage, { x: -100, opacity: 0.5, duration: 0.8, ease: "power2.out" })
        .from($rightInner, { x: 100, opacity: 0.4, duration: 1.2, ease: "power2.out" }, "-=1.0"); 
    });
  };


/* ==========================================================================
     Home Featured categories (.vog_offers_section)
     ========================================================================== */

  const initHomeFeaturedPrdsSection = () => {
    $('.vog-featured-collection').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".featured-col-left");
      var $headerRight = $wrapper.find(".featured-col-right");
      var $cardsWrapper       = $wrapper.find(".vog_grid_wrapper");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");

      if ($cardsWrapper.length) {
        tl.from($cardsWrapper, {
          y: 50, opacity: 0, duration: 0.8, ease: "back.out(1.2)",
          onComplete: function() { gsap.set($cardsWrapper, { clearProps: "transform" }); }
        }, "-=0.4");
      }
    });
  };


/* ==========================================================================
     Home OFFERS CARDS (.vog_offers_section)
     ========================================================================== */

  const initOffersSection = () => {
    $('.vog_offers_section').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".vog_header_left");
      var $headerRight = $wrapper.find(".vog_header_right");
      var $cards       = $wrapper.find(".vog_offer_card");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");

      if ($cards.length) {
        tl.from($cards, { y: 50, opacity: 0, duration: 0.8, stagger: 0.15, ease: "back.out(1.2)" }, "-=0.4");
      }
    });
  };


  /* ==========================================================================
     Home SERVICES GRID (.vog-our-services-grid)
     ========================================================================== */

  const initServicesGrid = () => {
    $('.vog-our-services-grid').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".featured-col-left");
      var $headerRight = $wrapper.find(".featured-col-right");
      var $wholeGrid   = $wrapper.find(".vog_services_grid");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");

      if ($wholeGrid.length) {
        tl.from($wholeGrid, { y: 60, opacity: 0, duration: 1.0, ease: "power2.out" }, "-=0.4");
      }
    });
  };


    /* ==========================================================================
     Home mega grid (.vog-featured-products-grid)
     ========================================================================== */

  const initMegaPrdsGrid = () => {
    $('.vog-featured-products-grid').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".featured-col-left");
      var $headerRight = $wrapper.find(".featured-col-right");
      var $wholeGrid   = $wrapper.find(".vog_mosaic_wrapper");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");

      if ($wholeGrid.length) {
        tl.from($wholeGrid, { y: 60, opacity: 0, duration: 1.0, ease: "power2.out" }, "-=0.4");
      }
    });
  };


  /* ==========================================================================
     Home mega grid (.vog-trust-badges-section)
     ========================================================================== */

  const initTrustBadges = () => {
    $('.vog-trust-badges-section').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $badgesSectionWrap  = $wrapper.find(".vog_trust_wrapper");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($badgesSectionWrap, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" });
    });
  };


  /* ==========================================================================
     Home product slider (.vog-product-slider-section)
     ========================================================================== */

  const initProductSliderAnimat = () => {
    $('.vog-product-slider-section').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".featured-col-left");
      var $headerRight = $wrapper.find(".featured-col-right");
      var $wholeSlider   = $wrapper.find(".vog-prds-slide-js");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");

      if ($wholeSlider.length) {
        tl.from($wholeSlider, { y: 60, opacity: 0, duration: 1.0, ease: "power2.out" }, "-=0.4");
      }
    });
  };


  /* ==========================================================================
     Header two col section (.js-two-col-header)
     ========================================================================== */

  const initHeadingTwoColSectionAnimat = () => {
    $('.js-two-col-header').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".featured-col-left");
      var $headerRight = $wrapper.find(".featured-col-right");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none"
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");
    });
  };


  /* ==========================================================================
     Instafeed section (#insta-feed)
     ========================================================================== */

  const initInstafeedAnimat = () => {
    $('#insta-feed').each(function() {
      var $instafeed_wrapper = $(this);
      if ($instafeed_wrapper.hasClass('vog-initialized')) return;
      $instafeed_wrapper.addClass('vog-initialized');

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $instafeed_wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none"
        }
      });

      if ($instafeed_wrapper.length) {
        tl.from($instafeed_wrapper, { y: 60, opacity: 0, duration: 1.0, ease: "power2.out" }, "-=0.4");
      }

    });
  };


  /* ==========================================================================
     AboutUs - video section (.vog_abt_vid)
     ========================================================================== */

  const initAbtVidSecAnimat = () => {
    $('.vog_abt_vid').each(function() {
      var $abt_vid_wrapper = $(this);
      if ($abt_vid_wrapper.hasClass('vog-initialized')) return;
      $abt_vid_wrapper.addClass('vog-initialized');

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $abt_vid_wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none"
        }
      });

      if ($abt_vid_wrapper.length) {
        tl.from($abt_vid_wrapper, { y: 60, opacity: 0, duration: 1.0, ease: "power2.out" }, "-=0.4");
      }

    });
  };


/* ==========================================================================
   AboutUs - Leadership section (.vog_leadership_section)
   ========================================================================== */

const initAbtLeardershipSecAnimat = () => {
  $('.vog_leadership_section').each(function() {
    var $wrapper = $(this);
    if ($wrapper.hasClass('vog-initialized')) return;
    $wrapper.addClass('vog-initialized');

    var $headerLeft  = $wrapper.find(".col-left");
    var $headerRight = $wrapper.find(".col-right");
    
    var $wholeCards  = $wrapper.find(".vog_leadership_grid");
    var $cards       = $wrapper.find(".vog_leadership_card");

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: $wrapper[0],
        start: "top 80%",
        toggleActions: "play none none none"
      }
    });


    if ($headerLeft.length) {
       tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" });
    }
    if ($headerRight.length) {
       tl.from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");
    }

    if ($wholeCards.length) {
      tl.from($wholeCards, { y: 40, opacity: 0, duration: 1.0, ease: "power2.out" }, "-=0.4");
    }


    if ($cards.length) {
       tl.from($cards, { 
         y: 50, 
         opacity: 0, 
         duration: 0.8, 
         stagger: 0.1,
         ease: "power2.out" 
       }, "-=0.4");
    }


  });
};


/* ==========================================================================
     About Us Awards and recognition section (.vog_award_section)
     ========================================================================== */

  const initAbtAwardRecogSection = () => {
    $('.vog_award_section').each(function() {
      var $wrapper = $(this);
      if ($wrapper.hasClass('vog-initialized')) return;
      $wrapper.addClass('vog-initialized');

      var $headerLeft  = $wrapper.find(".col-left");
      var $headerRight = $wrapper.find(".col-right");
      var $cards       = $wrapper.find(".vog_award_grid");

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none" // FIX: Play once only
        }
      });

      tl.from($headerLeft, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" })
        .from($headerRight, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");

      if ($cards.length) {
        tl.from($cards, { y: 50, opacity: 0, duration: 0.8, stagger: 0.15, ease: "back.out(1.2)" }, "-=0.4");
      }
    });
  };


/* ==========================================================================
   Vog Page Animations (Header & Content Groups)
   ========================================================================== */

const initVogTextBasedContentPageAnimations = () => {
  
  // Content Page Header Animation (.vog-page-header-section) -> return-policy/warranty/careguide etc all text based pages
  $('.vog-page-header-section').each(function() {
    var $wrapper = $(this);
    if ($wrapper.hasClass('vog-initialized')) return;
    $wrapper.addClass('vog-initialized');

    var $title = $wrapper.find("h1");
    var $sub   = $wrapper.find(".vog_header_sub");

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: $wrapper[0],
        start: "top 90%",
        toggleActions: "play none none none"
      }
    });

    if ($title.length) {
      tl.from($title, { y: 30, opacity: 0, duration: 0.8, ease: "power2.out" });
    }
    
    if ($sub.length) {
      tl.from($sub, { y: 20, opacity: 0, duration: 0.8, ease: "power2.out" }, "-=0.6");
    }
  });


  // Content Groups Animation (.vog-content-groups-section)
  $('.vog-content-groups-section').each(function() {
    var $wrapper = $(this);
    if ($wrapper.hasClass('vog-initialized')) return;
    $wrapper.addClass('vog-initialized');

    var $blocks = $wrapper.find(".vog-content-group-item");

    if ($blocks.length) {
      gsap.from($blocks, {
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 85%",
          toggleActions: "play none none none"
        },
        y: 40,  
        opacity: 0,
        duration: 0.8,
        stagger: 0.15, 
        ease: "power2.out"
      });
    }
  });

};


/* ==========================================================================
   Vog FAQ Section Animation
   ========================================================================== */

const initVogFaqAnimations = () => {
  
  $('.vog-faq-section').each(function() {
    var $wrapper = $(this);
    if ($wrapper.hasClass('vog-initialized')) return;
    $wrapper.addClass('vog-initialized');

    var $header = $wrapper.find(".vog-faq-header");
    var $faqList = $wrapper.find(".vog-faq-wrapper");

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: $wrapper[0],
        start: "top 85%",
        toggleActions: "play none none none"
      }
    });

    // Animate Header (Fade Up)
    if ($header.length) {
      tl.from($header, { 
        y: 40, 
        opacity: 0, 
        duration: 0.8, 
        ease: "power2.out" 
      });
    }

    //Animate FAQ Wrapper (Fade Up)
    if ($faqList.length) {
      tl.from($faqList, { 
        y: 50, 
        opacity: 0, 
        duration: 0.8, 
        ease: "power2.out" 
      }, "-=0.6");
    }

  });

};


/* ==========================================================================
   Vog Collection Banner Animation
   ========================================================================== */

const initVogCollectionBannerAnimations = () => {

  $('.vog-collection-top-banner').each(function() {
    var $wrapper = $(this);
    if ($wrapper.hasClass('vog-initialized')) return;
    $wrapper.addClass('vog-initialized');

    var $content = $wrapper.find('.inner-content');

    if ($content.length) {
      gsap.from($content, {
        scrollTrigger: {
          trigger: $wrapper[0],
          start: "top 80%",
          toggleActions: "play none none none"
        },
        y: 50,
        opacity: 0.4,
        duration: 1.2,
        ease: "power2.out"
      });
    }

  });

};


  /*================================================
  Vog Product Slider product add script
  ================================================== */
const buttons = document.querySelectorAll('.js-vog-prd-card-add-to-cart-ajax');
const cartDrawerComponent = document.querySelector('cart-drawer-component'); 

buttons.forEach(btn => {
  btn.addEventListener('click', function() {
    
    const originalText = btn.innerHTML;
    const vid = this.getAttribute('data-id');
    const pqty = this.getAttribute('data-qty');

    btn.style.cursor = 'not-allowed';
    btn.innerHTML = 'MAKING...';
    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: pqty }] })
      })
      .then(response => response.json())
      .then(cartData => {

        fetch(window.Shopify.routes.root + "?sections=cart-drawer,cart-icon-bubble")
          .then(res => res.json())
          .then(sections => {

            // Update Icon
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && sections['cart-icon-bubble']) {
                const parsedIcon = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
                const newIcon = parsedIcon.querySelector('#cart-icon-bubble');
                cartIconBubble.innerHTML = newIcon ? newIcon.innerHTML : sections['cart-icon-bubble'];
            }

            // Update Drawer Content
            const cartDrawerContent = document.querySelector('#CartDrawer');
            if (cartDrawerContent && sections['cart-drawer']) {
                const parsedDrawer = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                const newDrawer = parsedDrawer.querySelector('#CartDrawer') || parsedDrawer.querySelector('cart-items-component');
                
                if (newDrawer) {
                    cartDrawerContent.innerHTML = newDrawer.innerHTML;
                    if (cartDrawerComponent) cartDrawerComponent.classList.remove('is-empty');
                }
            }

            import('@theme/events').then(({ CartUpdateEvent }) => {
                
                const event = new CartUpdateEvent(cartData, 'manual-trigger', {
                    itemCount: cartData.item_count,
                    source: 'vog-custom-add',
                    sections: sections 
                });
                
                document.dispatchEvent(event);
                
                // Open Drawer
                if (cartDrawerComponent && cartDrawerComponent.hasAttribute('auto-open')) {
                    cartDrawerComponent.open();
                } else if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
                    cartDrawerComponent.open();
                }
                
            }).catch(err => {
                console.warn('Could not load @theme/events, using fallback.', err);
                document.dispatchEvent(new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: { cart: cartData, sections: sections }
                }));
                 if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
                    cartDrawerComponent.open();
                }
            });

            // --- Reset Button ---
            btn.innerHTML = 'Added!';
            setTimeout(() => {
                btn.innerHTML = originalText;
                btn.style.cursor = 'pointer';
                btn.disabled = false;
            }, 2000);

          });
      })
      .catch((error) => {
        console.error('Error:', error);
        btn.innerHTML = 'Error';
        setTimeout(() => {
           btn.innerHTML = originalText;
           btn.style.cursor = 'pointer';
           btn.disabled = false;
        }, 2000);
      });
  });
});



/* ==========================================================================
   SECTION: PRODUCT SLIDER (.vog-prds-slide-js)
   ========================================================================== */

const initProductSlider = () => {

  $('.vog-prds-slide-js').each(function() {
    
    var $sliderContainer = $(this);

    if ($sliderContainer.hasClass('swiper-initialized')) return;

    // Initialize Swiper
    new Swiper($sliderContainer[0], {
      slidesPerView: 1.3,
      spaceBetween: 15, 
      loop: false, 
      grabCursor: true, 
      navigation: {
        nextEl: $sliderContainer.find('.swiper-button-next')[0],
        prevEl: $sliderContainer.find('.swiper-button-prev')[0],
      },

      // Responsive Breakpoints
      breakpoints: {
        576: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        }
      }
    });
  });
};


/* ==========================================================================
   PRODUCT PAGE RELATIVE PRODUCTS SLIDER (.vog-rel-prds-slide-js)
   ========================================================================== */

const initRelativeProductSlider = () => {

  $('.vog-rel-prds-slide-js').each(function() {
    
    var $sliderContainer = $(this);

    if ($sliderContainer.hasClass('swiper-initialized')) return;

    // Initialize Swiper
    new Swiper($sliderContainer[0], {
      slidesPerView: 1.3,
      spaceBetween: 15, 
      loop: false, 
      grabCursor: true, 
      navigation: {
        nextEl: $sliderContainer.find('.swiper-button-next')[0],
        prevEl: $sliderContainer.find('.swiper-button-prev')[0],
      },

      // Responsive Breakpoints
      breakpoints: {
        576: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        }
      }
    });
  });
};



/* ==========================================================================
   COLLECTION PAGE BEST SELLING PRODUCTS SLIDER (.vog-collection-best-sell-prds-slide-js)
   ========================================================================== */

const initCollectionBestSellingProductSlider = () => {

  $('.vog-collection-best-sell-prds-slide-js').each(function() {
    
    var $sliderContainer = $(this);

    if ($sliderContainer.hasClass('swiper-initialized')) return;

    // Initialize Swiper
    new Swiper($sliderContainer[0], {
      slidesPerView: 1.3,
      spaceBetween: 15, 
      loop: false, 
      grabCursor: true, 
      navigation: {
        nextEl: $sliderContainer.find('.swiper-button-next')[0],
        prevEl: $sliderContainer.find('.swiper-button-prev')[0],
      },

      // Responsive Breakpoints
      breakpoints: {
        576: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 15,
        }
      }
    });
  });
};

/* ==========================================================================
     EXECUTION & SHOPIFY EVENTS
     ========================================================================== */

    initAllAnimations();
    initProductSlider();
    initRelativeProductSlider();
    initCollectionBestSellingProductSlider();

    $(document).on('shopify:section:load', function() {
      initAllAnimations();
      initProductSlider();
      initRelativeProductSlider();
      initCollectionBestSellingProductSlider();
    });

//----------------------------------------------------------------


});



  document.addEventListener('DOMContentLoaded', () => {
    const pickerContainer = document.querySelector('variant-picker[data-section-id="{{ section.id }}"]');
    if (!pickerContainer) return;

    // This function checks the dropdown and forces the correct display state
    function enforceMessageState() {
      const selectEle = pickerContainer.querySelector('.variant-option__select');
      const msgBox = pickerContainer.querySelector('#vog-variant-backorder-msg');
      
      if (!selectEle || !msgBox) return;

      const selectedOption = selectEle.options[selectEle.selectedIndex];
      if (!selectedOption) return;

      const isBackorder = selectedOption.getAttribute('data-is-backorder') === 'true';

      if (isBackorder) {
        msgBox.style.display = 'flex'; 
      } else {
        msgBox.style.display = 'none';
      }
    }

    const observer = new MutationObserver((mutations) => {
      observer.disconnect(); 
      
      enforceMessageState(); 
      
      observer.observe(pickerContainer, { childList: true, subtree: true, attributes: true });
    });

    observer.observe(pickerContainer, { childList: true, subtree: true, attributes: true });

    pickerContainer.addEventListener('change', () => {
      setTimeout(enforceMessageState, 50);
    });
  });